 
 import React from "react";
import style from "./About.module.css";
import img1 from "../../assets/home_images/CEO.jpg";

const Foundingteam = () => {
  const boxes = [
    {
      img: img1,
      name: "Aditya Kumar",
      alt: "Chief Executive Officer",
      role: "Chief Executive Officer",
      description:
        "Empowering businesses with innovative solutions, strategic execution, and a culture of resilience and excellence.",
    },
    // {
    //     img: img2,
    //     name: "Deepak Rao",
    //     role: "Director",
    //     description: "Driving innovation with expert leadership, robust cloud solutions, and a commitment to mentoring future tech leaders."
    // },
    // {
    //     img: img3,
    //     name: "Srinivas",
    //     role: "IT Manager",
    //     description: "Delivering exceptional design and innovation with a user-centric approach, driven by expertise in product management and creative problem-solving."
    // },
    // {
    //     img: img4,
    //     name: "Krishna",
    //     role: "Product Owner",
    //     description: "Building a standout brand with innovative marketing, strategic messaging, and impactful product positioning."
    // },
  ];

  return (
    <div style={{ color: "black" }}>
      <div className={style.team_head}>
        <h2>Our Founding Team</h2>
        <br />
        <p>
          At Aspiron Tech, our team thrives on passion, creativity, and synergy.
          With a relentless drive for excellence, we work together to craft
          innovative solutions, consistently surpassing expectations and leaving
          a meaningful imprint in everything we do.
        </p>
        {/* <p>Our dedicated team is fueled by passion and collaboration, delivering innovative solutions with a shared vision and unwavering determination, our team goes above and beyond to exceed expectations and make a lasting impact</p> */}
      </div>
      <br />
      <br />
      <div className={style.team_boxs_cntr}>
        {boxes.map((each, index) => (
          <div className={style.team_boxs}>
            <img src={each.img} style={{ borderRadius: "10px" }} alt="img"/>

            <div style={{ margin: "auto" }}>
              <h3>
                {each.name}
                <br />
                <p>{each.role}</p>
              </h3>

              <p>{each.description}</p>
            </div>
          </div>
        ))}
      </div>
      <br />
      <br />
    </div>
  );
};

export default Foundingteam;
